import React from "react";
import useFilter from "../Hooks/useFilter";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
}));

export default function Positabs() {
  const filter = useFilter();
  const { state } = useFilter();
  const classes = useStyles();

  const handleChange = (event, newValue) => {
    filter.setPosiNegaTab(event.target.value);
  };

  return (
    <FormControl className={classes.formControl}>
      <InputLabel id="posi-tabs-label">ポジ/ネガ</InputLabel>
      <Select
        labelId="posi-tabs-label"
        id="posi-tabs"
        value={state.posiNegaTab}
        onChange={handleChange}
      >
        <MenuItem value="all">全て</MenuItem>
        <MenuItem value="positive">ポジティブ</MenuItem>
        <MenuItem value="negative">ネガティブ</MenuItem>
      </Select>
    </FormControl>
  );
}
